var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 27,
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2727 16.875V3.375C30.2727 1.51875 28.7591 0 26.9091 0H3.36364C1.51364 0 0 1.51875 0 3.375V16.875C0 18.7313 1.51364 20.25 3.36364 20.25H26.9091C28.7591 20.25 30.2727 18.7313 30.2727 16.875ZM15.1364 15.1875C12.3445 15.1875 10.0909 12.9262 10.0909 10.125C10.0909 7.32375 12.3445 5.0625 15.1364 5.0625C17.9282 5.0625 20.1818 7.32375 20.1818 10.125C20.1818 12.9262 17.9282 15.1875 15.1364 15.1875ZM37 5.0625V23.625C37 25.4813 35.4864 27 33.6364 27H5.04545V23.625H33.6364V5.0625H37Z",
    fill: "#294764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.ac470f56abf1769f7f4d24f8babcbe34.svg";
export { ForwardRef as ReactComponent };